import React from 'react';

interface InputFormProps {
    name: string;
    label: string;
    value: string;
    error: string;
    mask: string;
    options: { name: string; id: string }[];
    hint: string;
    required: boolean;
    onChange: (any) => void;
}

const Select = ({ name, label, value, error, onChange, options, mask, hint, required }: InputFormProps) => {
    return (
        <div className={error ? 'form-group novalidate' : 'form-group'}>
            <label htmlFor={name}>
                {label}:{required ? '*' : ''}
            </label>
            <select value={value} name={name} id={name} onChange={onChange} className="form__select">
                {options.map(option => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select>
            {error && (
                <div className="alert alert-danger">
                    <>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            className="form__error-svg"
                        >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                        </svg>
                        {error}
                    </>
                </div>
            )}
            {hint && <div className="hint">{hint}</div>}
        </div>
    );
};

Select.defaultProps = {
    mask: 'none',
    hint: null,
    required: null,
    value: '',
};
export default Select;
